import bestRatedSongs from "./charts/bestRatedSongs";
import worstRatedSongs from "./charts/worstRatedSongs";
import { Controller } from "stimulus";
import Chart from "chart.js/auto";

export default class extends Controller {
  destroyChart(id) {
    const chart = Chart.getChart(id);
    if (chart !== undefined) chart.destroy();
  }

  createChart({ canvasID, options, data, type }) {
    const ctx = document.querySelector(`#${canvasID}`);
    const chart = new Chart(ctx, {
      type,
      data,
      options,
    });
    return chart;
  }

  initialize() {
    this.destroyChart("best-rated-songs");
    this.destroyChart("worst-rated-songs");
  }

  connect() {
    const bestData = $("#best-rated-songs").data("bestRates");
    const worstData = $("#worst-rated-songs").data("worstRates");
    if (bestData) this.createChart(bestRatedSongs());
    if (worstData) this.createChart(worstRatedSongs());
  }
}
